import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

export const ADMIN_PANEL_ANNOUNCEMENTS =
  "/admin-panel/announcements/waiting-for-approval";
export const HOME = "/";
export const ABOUT_US = "/about-us";
export const USER_ZONE = "/user-zone";
export const MASSAGE_MASTER_ZONE = "/massage-master-zone";
export const ACCOUNT = "/account";
export const SEARCH_MASSAGE = "/search-massage";
export const SIGN_IN = "/sign-in";
export const SIGN_UP = "/sign-up";
export const CHANGE_PASSWORD = USER_ZONE + "/change-password";
export const CHANGE_EMAIL = USER_ZONE + "/change-email";
export const CHANGE_EMAIL_CONFIRM_CURRENT =
  ACCOUNT + "/change-email/confirm-current";
export const CHANGE_EMAIL_CONFIRM_NEW = ACCOUNT + "/change-email/confirm-new";
export const REGULATIONS = "/regulations";
export const SERVICE_TERMS = REGULATIONS + "?tab=service-terms";
export const PRIVACY_POLICY = REGULATIONS + "?tab=privacy-policy";
export const PROVIDED_MASSAGES = "/#providedMassages";

export const PROFILE_SETTINGS = USER_ZONE + "/profile-settings";

export const PROFILE_SUMMARY_TAB = PROFILE_SETTINGS + "?tab=summary";
export const CALENDAR_TAB = PROFILE_SETTINGS + "?tab=calendar";
export const CLIENT_CARD_TAB = PROFILE_SETTINGS + "?tab=client-card";
export const WAITING_ANNOUNCEMENTS = PROFILE_SETTINGS + "?tab=waiting";

export const BOOKING_PARTNER_PROFILE = "/booking";

export const SEARCH_PARTNER_PROFILE = "/partner";

export const PROFILE_DETAILS = SEARCH_MASSAGE + "/profile-details";

export const EDIT_CLIENT_PROFILE = USER_ZONE + "/edit-client-profile";

export const POST_NEW_PARTNER_PROFILE = USER_ZONE + "/add-partner-profile";

export const EDIT_PARTNER_PROFILE = USER_ZONE + "/edit-partner-profile";

export const EDIT_PARTNER_PROFILE_SUCCESS = EDIT_PARTNER_PROFILE + "/success";

export const POST_NEW_ANNOUNCEMENT = USER_ZONE + "/add-announcement";
export const POST_NEW_PARTNER_PROFILE_SUCCESS =
  POST_NEW_PARTNER_PROFILE + "/success";

export const EDUCATION = USER_ZONE + "/education";
export const SUPPLY = USER_ZONE + "/supply";

export const PAYMENT_RETURN = USER_ZONE + "/payment-return";
export const POST_NEW_ANNOUNCEMENT_WAIT = PAYMENT_RETURN + "/add/wait";
export const PAYMENT = USER_ZONE + "/payment";
export const SIGN_UP_SUCCESS = SIGN_UP + "/success";
export const FORGOT_PASSWORD = "/forgot-password";
export const RESET_PASSWORD = USER_ZONE + "/reset-password";
export const MASSAGE_MASTER_ZONE_PRICE = USER_ZONE + "#price";
export const MASSAGE_MASTER_ZONE_BENEFITS = USER_ZONE + "#benefits";

export const SEARCH_RELAXED_MASSAGE = SEARCH_MASSAGE + "?category=relaxing";
export const SEARCH_SENSUAL_MASSAGE = SEARCH_MASSAGE + "?category=sensual";
export const SEARCH_PHYSIOTHERAPY = SEARCH_MASSAGE + "?category=physiotherapy";
export const SEARCH_OSTEOPATHY = SEARCH_MASSAGE + "?category=osteopathy";
export const SEARCH_ACUPUNCTURE = SEARCH_MASSAGE + "?category=acupuncture";
export const SEARCH_CHIROPRACTIC = SEARCH_MASSAGE + "?category=chiropractic";
export const SEARCH_REFLEXOTHERAPY =
  SEARCH_MASSAGE + "?category=reflexotherapy";
export const SEARCH_HIRUDOTHERAPY = SEARCH_MASSAGE + "?category=hirudotherapy";
export const EDIT_ANNOUNCEMENT = USER_ZONE + "/edit-announcement";
export const DUPLICATE_ANNOUNCEMENT = USER_ZONE + "/duplicate-announcement";
export const ACTIVATE_ANNOUNCEMENT = USER_ZONE + "/activate-announcement";
export const FIX_ANNOUNCEMENT = USER_ZONE + "/fix-announcement";
export const EXTEND_ANNOUNCEMENT = USER_ZONE + "/extend-announcement";
export const EXTEND_ANNOUNCEMENT_WAIT = PAYMENT_RETURN + "/extend/wait";
export const GET_LOCATION = "https://geocode.maps.co/reverse";
export const IOS_MOBILE_APP =
  "https://apps.apple.com/pl/app/simplymassage-app/id6502907659";
export const ANDROID_MOBILE_APP =
  "https://play.google.com/store/apps/details?id=com.simplymassage";
export const MOBILE_APP = "/mobile-app";

export const ANNOUNCEMENT_DETAILS_PATH = (id: string) =>
  `/search-massage/announcement-details/${id}`;
export const EDIT_ANNOUNCEMENT_PATH = (id: string) =>
  `/user-zone/edit-announcement/${id}`;
export const DUPLICATE_ANNOUNCEMENT_PATH = (id: string) =>
  `/user-zone/duplicate-announcement/${id}`;
export const ACTIVATE_ANNOUNCEMENT_PATH = (id: string) =>
  `/user-zone/activate-announcement/${id}`;
export const FIX_ANNOUNCEMENT_PATH = (id: string) =>
  `/user-zone/fix-announcement/${id}`;
export const EXTEND_ANNOUNCEMENT_PATH = (id: string) =>
  `/user-zone/extend-announcement/${id}`;
